import {
	FAQ_ROUTE_ID,
} from 'root/src/shared/descriptions/routes/routeIds'

import {
	FAQ_MODULE_ID,
	FAQ_BANNER_HEADER_MODULE_ID,
} from 'root/src/shared/descriptions/modules/moduleIds'

export default {
	[FAQ_ROUTE_ID]: {
		url: '/FAQ',
		modules: [
			FAQ_BANNER_HEADER_MODULE_ID,
			FAQ_MODULE_ID,
		],
	},
}
